import {
  ErrorBoundary,
  Layout,
  Results as ResultsPage,
  SimpleResults as SimpleResultsPage,
} from '../components';
import { useAuth } from '../providers';

const Results = () => {
  const { detailedScreen } = useAuth();

  return (
    <Layout
      justifyContent="flex-start"
      alignItems="center"
      flexDirection="column"
    >
      <ErrorBoundary>
        {detailedScreen === null || detailedScreen === true ? (
          <ResultsPage />
        ) : (
          <SimpleResultsPage />
        )}
      </ErrorBoundary>
    </Layout>
  );
};

export default Results;
